import { render } from "./TimeSince.vue?vue&type=template&id=d7246cc8"
import script from "./TimeSince.vue?vue&type=script&lang=js"
export * from "./TimeSince.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__